import { useEffect } from 'react';
import { QueryContainer } from '@opensearch-project/opensearch/api/_types/_common.query_dsl';
import cloneDeep from 'lodash/cloneDeep';

import { useOpenSearchContext } from './useOpenSearchContext';

const useSearchBox = () => {
  const {
    queryFiltersByFacets,
    updateQueryFiltersByFacets,
    searchableAtributes,
  } = useOpenSearchContext();

  const searchTerm =
    (queryFiltersByFacets.search as QueryContainer)?.multi_match?.query || '';

  const handleRefine = (searchText: string) => {
    updateQueryFiltersByFacets(prev => {
      const clonedPrev = cloneDeep(prev);

      if (!searchText) {
        delete clonedPrev.search;
        return clonedPrev;
      }

      return {
        ...prev,
        search: {
          multi_match: {
            query: searchText,
            fields: searchableAtributes ?? [],
            fuzziness: 2,
          },
        },
      };
    });
  };

  useEffect(() => {
    updateQueryFiltersByFacets(prev => {
      const clonedPrev = { ...prev };
      if (!clonedPrev.search) {
        return clonedPrev;
      }

      const query = (prev.search as QueryContainer)?.multi_match?.query || '';

      return {
        ...prev,
        search: {
          multi_match: {
            query,
            fields: searchableAtributes ?? [],
            fuzziness: 2,
          },
        },
      };
    });
  }, [searchableAtributes]);

  return { searchTerm, refine: handleRefine };
};

export { useSearchBox };
